import React from "react";
import styles from "./SquareIcon.module.scss";
import {MDBTooltip} from 'mdbreact';
import {If, Then} from "react-if";

export interface ISquareIcon {

  style: any;
  showIcon: boolean;
  iconElement?: any;
  icon: any;
  toolTip: string;
  iconContainerClassName?: string;
  iconClassName?: string;
}

/*
const SquareIconWithoutTooltip = props => (
  <div style={{
    position: 'absolute',
    marginRight: 0,
    top: 10,
    right: 0,
    width: 32,
    height: 32,
    zIndex: 99,
    borderRadius: 4,
    ...props.style
  }}
       className={props.iconContainerClassName}
  >
    {props.iconElement ? props.iconElement : <props.icon
      style={{
        backgroundColor: "#05BEC0",
        color: "white",
        borderRadius: 4,
        padding: 4,
        width: 32,
        height: 32,
        ...props.style
      }}
      className={props.iconClassName}
    />}
  </div>
);
*/
const SquareIcon = (props: ISquareIcon) => (
  <If condition={!!(props.showIcon && (props.icon || props.iconElement))}>
    <Then>
      {() => <MDBTooltip
        domElement
        tag="span"
        placement="top"
      >
        <div style={{
          ...props.style
        }}
             className={`${styles.iconContainerClassName} ${props.iconContainerClassName} squareIcon`.trim()}
        >
          {props.iconElement ? props.iconElement : <props.icon
            style={{
              ...props.style
            }}
            className={`${styles.iconClassName} ${props.iconClassName}`.trim()}
          />}
        </div>
        <span>{props.toolTip}</span>
      </MDBTooltip>
      }
    </Then>
  </If>
);

SquareIcon.defaultProps = {
  showIcon: true,
  style: {},
  icon: null,
  toolTip: "",
  iconClassName: '',
  iconContainerClassName: '',
};

export default SquareIcon;
